import SHSkeleton from "@components/design-systems/sh-skeleton";
import { SHStack } from "@components/design-systems";

export const AnalysisToolbarButtonsSkeleton = () => {
  return (
    <SHStack direction={"row"} gap={2}>
      <SHSkeleton
        height={38}
        width={70}
        sx={{
          borderRadius: "100px",
        }}
      />
      <SHSkeleton
        height={38}
        width={70}
        sx={{
          borderRadius: "100px",
        }}
      />
      <SHSkeleton
        height={38}
        width={70}
        sx={{
          borderRadius: "100px",
        }}
      />
    </SHStack>
  );
};
